import { render, staticRenderFns } from "./UserPasswordResetView.vue?vue&type=template&id=bbf426a4"
import script from "./UserPasswordResetView.vue?vue&type=script&lang=ts"
export * from "./UserPasswordResetView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports